
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("e14IX", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $4Vdlk = parcelRequire("4Vdlk");


var $iIYTj = parcelRequire("iIYTj");


var $luv00 = parcelRequire("luv00");

const $ffaacbf4faa73d50$export$ed7a1c0e36312b6a = 'is-dragging-tree-item';


const $83aac7cff8f4987b$var$isSmartLinkDraggingClass = 'is-smart-link-dragging';
function $83aac7cff8f4987b$export$e5989385da3155c8(t0) {
    const $ = (0, $bDgLe.c)(8);
    const { setIsDraggingItem: setIsDraggingItem, itemType: t1 } = t0;
    const itemType = t1 === undefined ? "tree-item" : t1;
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    let t2;
    let t3;
    if ($[0] !== itemType || $[1] !== setIsDraggingItem) {
        t2 = ()=>(0, $4Vdlk.monitorForElements)({
                canMonitor: (t4)=>{
                    const { source: source } = t4;
                    return source.data.type === itemType || (0, $iIYTj.isSmartLinkDrag)(source.data.type);
                },
                onGenerateDragPreview: (t5)=>{
                    const { source: source_0 } = t5;
                    setIsDraggingItem?.(true);
                    document.body.classList.add((0, $ffaacbf4faa73d50$export$ed7a1c0e36312b6a));
                    if ((0, $iIYTj.isSmartLinkDrag)(source_0.data.type)) document.body.classList.add($83aac7cff8f4987b$var$isSmartLinkDraggingClass);
                },
                onDrop: ()=>{
                    setIsDraggingItem?.(false);
                    document.body.classList.remove((0, $ffaacbf4faa73d50$export$ed7a1c0e36312b6a));
                    document.body.classList.remove($83aac7cff8f4987b$var$isSmartLinkDraggingClass);
                }
            });
        t3 = [
            setIsDraggingItem,
            itemType
        ];
        $[0] = itemType;
        $[1] = setIsDraggingItem;
        $[2] = t2;
        $[3] = t3;
    } else {
        t2 = $[2];
        t3 = $[3];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    let t5;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = function mount() {
            return function unmount() {
                document.body.classList.remove((0, $ffaacbf4faa73d50$export$ed7a1c0e36312b6a));
                document.body.classList.remove($83aac7cff8f4987b$var$isSmartLinkDraggingClass);
            };
        };
        t5 = [];
        $[4] = t4;
        $[5] = t5;
    } else {
        t4 = $[4];
        t5 = $[5];
    }
    (0, $cozmU.useEffect)(t4, t5);
    let t6;
    if ($[6] !== ssrPlaceholderIdProp) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": "tree-monitor",
            "data-vc": "tree-monitor",
            ...ssrPlaceholderIdProp
        });
        $[6] = ssrPlaceholderIdProp;
        $[7] = t6;
    } else t6 = $[7];
    return t6;
}
module.exports["TreeMonitor"] = $83aac7cff8f4987b$export$e5989385da3155c8;

});

parcelRegister("luv00", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5nSna = parcelRequire("5nSna");

const $8a88875ffe13fd4c$export$30b62f74ca853d7d = (0, $3u0dr.isReactCompilerActiveV2)() ? function useSSRPlaceholderReplaceIdProp() {
    const $ = (0, $bDgLe.c)(2);
    const { placeholderReplaceId: placeholderReplaceId } = (0, $cozmU.useContext)((0, $5nSna.LoadableAncestorsContext));
    let t0;
    if ($[0] !== placeholderReplaceId) {
        t0 = {
            "data-ssr-placeholder-replace": placeholderReplaceId
        };
        $[0] = placeholderReplaceId;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : function useSSRPlaceholderReplaceIdProp() {
    const { placeholderReplaceId: placeholderReplaceId } = (0, $cozmU.useContext)((0, $5nSna.LoadableAncestorsContext));
    return {
        'data-ssr-placeholder-replace': placeholderReplaceId
    };
};
module.exports["useSSRPlaceholderReplaceIdProp"] = $8a88875ffe13fd4c$export$30b62f74ca853d7d;

});

parcelRegister("7jfHQ", function(module, exports) {
const $dc3179d69ab4f7dc$export$bcf275804417edda = (details)=>{
    if (details?.data && 'icon' in details.data && details.data.icon) {
        if (typeof details.data.icon === 'object' && 'url' in details.data.icon && details.data.icon.url && typeof details.data.icon.url === 'string') return details.data.icon.url;
    }
    return undefined;
};
module.exports["getObjectIconUrl"] = $dc3179d69ab4f7dc$export$bcf275804417edda;

});


//# sourceMappingURL=TreeMonitor.4ab76d94.js.map
